export default __webpack_public_path__ + "static/media/mark-close.14a4a0ff.jpg";